/*
 * Card / panel container. White bg, soft hairline border, large radius,
 * sm shadow.
 */
import { styled } from '@mui/material/styles';

const GpCard = styled('section', {
  shouldForwardProp: (prop) => prop !== 'padding',
})(({ padding = 24 }) => ({
  background: 'var(--gp-card)',
  border: '1px solid var(--gp-hairline)',
  borderRadius: 'var(--gp-r-lg)',
  padding,
  boxShadow: 'var(--gp-shadow-sm)',
}));

export default GpCard;
